export default __webpack_public_path__ + "static/media/purpleArrow.d7141984.svg";